import { dispatchSnackbarNegativeEvent } from '@dreryk/react-components';

import { translationKeys } from '../translations';

/**
 * Fault handlers shared by all AI-assistant CQRS commands that can fail
 * with the standard set of AI-assistant faults.
 *
 * Spread into useCqrsCommand onFault options and add command-specific entries.
 */
export const AI_ASSISTANT_FAULT_HANDLERS = {
   'egabinet-ai-assistant-frontend-api:FeatureNotEnabledFault': (): void => {
      dispatchSnackbarNegativeEvent(translationKeys.faults.featureNotEnabled);
   },
   'egabinet-ai-assistant-frontend-api:QuotaExceededFault': (): void => {
      dispatchSnackbarNegativeEvent(translationKeys.faults.quotaExceeded);
   },
   'egabinet-ai-assistant-frontend-api:PromptUnavailableFault': (): void => {
      dispatchSnackbarNegativeEvent(translationKeys.faults.bedrockUnavailable);
   },
   'egabinet-ai-assistant-frontend-api:PromptTimeoutFault': (): void => {
      dispatchSnackbarNegativeEvent(translationKeys.faults.bedrockTimeout);
   },
} as const;
